module.exports = __webpack_public_path__ + "img/antenna.png";